module.exports = __webpack_public_path__ + "media/images/case-studies/jonai-b501846977e131c6db135bf50abe867f.png";